import { Row, Col, Form, Input, Button, Typography } from "antd";
import React, { useEffect, useState } from "react";
import API_KEY from "../../../api";
import { randomString } from "../../../utils/randomString";
import { useHistory } from "react-router-dom";
import axios from "axios";
const { Title, Text } = Typography;
export default function CopyModal({
  isModalVisible,
  setIsModalVisible,
  setId,
  setModalType,
  actionLoading,
  setActionLoading,
  details,
  fetchCollections,
}) {
  const [currentCollectionMeta, setCurrentCollectionDetails] = useState({});
  const { collection_name = "", id } = details;
  const history = useHistory();

  const onCancel = () => {
    setIsModalVisible(false);
  };
  // const onFinishFailed = (e) => {};
  const onFinish = (values) => {
    setActionLoading(true);
    var org = localStorage.getItem("org");
    const orgId = JSON.parse(org).id;
    const user = JSON.parse(localStorage.getItem("user"));

    const payload = {
      ...values,
      exporter_name: currentCollectionMeta?.exporter_name,
      logo: currentCollectionMeta?.logo,
      banner_image: currentCollectionMeta?.banner_image,
      collection_link: randomString(7),
      manufacturer: orgId,
    };

    API_KEY.URL.post(API_KEY.path.collections, payload)
      .then((response) => {
        if (response.status === 200) {
          const collectionId = response.data.data.id;
          const productPayload = currentCollectionMeta.products.map((item) => {
            return {
              products_id: item.products_id.id,
              variants: item.variants,
              visible_attributes: item.visible_attributes || [],
              sub_category:
                typeof item?.sub_category === "object"
                  ? item.sub_category.join(",")
                  : item.sub_category,
              attributes: item.attributes.map((attribute) => {
                return {
                  attribute_values_id: {
                    attribute_id: attribute.attribute_values_id.attribute_id.id,
                    values: attribute.attribute_values_id.values || null,
                    composite: attribute.attribute_values_id.composite || null,
                  },
                };
              }),
            };
          });

          const completePayload = {
            products: productPayload,
            visible_attributes:
              typeof currentCollectionMeta.visible_attributes === "object"
                ? currentCollectionMeta.visible_attributes.join(",")
                : currentCollectionMeta.visible_attributes,
          };

          axios
            .post(
              `${process.env.REACT_APP_API_SERVICE}items/collections/?collections_id=${collectionId}&token=${user?.access_token}`,
              completePayload
            )
            .then((result) => {
              if (result.status === 200) {
                history.push(`/catalogue-table/${collectionId}/edit`);
                fetchCollections();
                setModalType(null);
                setId(null);
                setIsModalVisible(false);
                setActionLoading(false);
              }
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (id) {
      const user = localStorage.getItem("user");
      const token = JSON.parse(user).access_token;
      // filter: { id: { _eq: req.params.pk } },
      const fields = [
        "*",
        "products.id",
        "products.sub_category",
        "products.products_id.secondary_category.id",
        "products.products_id.product_id",
        "products.products_id.id",
        "products.products_id.secondary_category.name",
        "products.products_id.product_images.directus_files_id",
        "products.attributes.attribute_values_id.*",
        "products.attributes.attribute_values_id.attribute_id.id",
        "products.attributes.attribute_values_id.attribute_id.name",
        "products.attributes.attribute_values_id.attribute_id.dtype",
        "products.attributes.attribute_values_id.attribute_id.is_internal",
        "products.attributes.attribute_values_id.attribute_id.default",
        "products.visible_attributes",
        "products.variants.attributes.attribute_values_id.values",
        "products.variants.attributes.attribute_values_id.attribute_id",
        "products.variants.attributes.attribute_values_id.composite",
        "products.variants.variant_id",
      ];

      let url = `${process.env.REACT_APP_DIRECTUS}items/collections?token=${token}&`;

      url = url + `fields=${fields.join(",")}&`;
      url = url + `filter[id][_eq]=${id}&`;
      url = url + `limit=-1`;
      API_KEY.URL.get(url).then((res) => {
        setCurrentCollectionDetails(res.data.data[0]);
      });
    }
  }, [id]);
  const copyCatalogueTitle = `Creating a copy of "${collection_name}"`;
  const copyCatalogueContent =
    "For creating a new catalogue, you need to rename it or add another buyer's details";

  return (
    <div>
      <Row justify="left" style={{ textAlign: "left" }}>
        <Col>
          <Title level={4}>{copyCatalogueTitle}</Title>
        </Col>
      </Row>

      <Row justify="left" style={{ textAlign: "left" }}>
        <Col>
          <Text>{copyCatalogueContent}</Text>
        </Col>
      </Row>
      <Form
        // form={form}
        name="create-collection"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
      >
        <Row style={{ marginTop: "2.5rem" }}>
          <Col xl={{ span: 24 }}>
            <Text type="secondary">
              Name of the new Catalogue <span style={{ color: "red" }}>*</span>
            </Text>
            <Form.Item
              className="form-label"
              name="collection_name"
              // label="Name of the catalogue"
              // {...formItemLayout}
              rules={[
                { required: true, message: "Catalogue name is required" },
              ]}
            >
              <Input
                // required
                // placeholder="Catalogue name"
                size="large"
              />
            </Form.Item>

            <Text type="secondary">
              Buyer Name <span style={{ color: "red" }}>*</span>
            </Text>
            <Form.Item
              className="form-label"
              // label="Buyer Company"
              name="buyer_name"
              // {...formItemLayout}
              rules={[{ required: true, message: "Buyer name is required" }]}
            >
              <Input
                // required
                size="large"
                // placeholder="Full name of the Buying company/Agency"
              />
            </Form.Item>

            <Text type="secondary">Buyer Email ID (Optional)</Text>
            <Form.Item
              className="form-label"
              // label="Buyer Email ID (optional)"
              name="email_ids"
              // {...formItemLayout}
              rules={[
                {
                  type: "email",
                  required: false,
                  message: "Enter valid email",
                },
              ]}
            >
              <Input
                // placeholder="Enter buyer email"
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" style={{ marginTop: "2rem" }}>
          <Col>
            <Button
              // loading={actionLoading}
              onClick={onCancel}
              size="large"
              className="copy-catalogue-button"
            >
              Cancel
            </Button>
          </Col>
          <Col span={6}>
            <Button
              loading={actionLoading}
              style={{
                width: "100px",
                border: 0,
                background: "#363E3D",
                color: "white",
                cursor: "pointer",
              }}
              className="copy-catalogue-button"
              type="primary"
              htmlType="submit"
              size="large"
              //  onClick={() => confirm()}
            >
              Create
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
